import * as yup from 'yup';

export const createContractFileModuleSchema = yup.object().shape({

});